$shm_hitalama_form_submit $mol_button_major
	dom_name \mol_button_major
